module.exports = __webpack_public_path__ + "static/media/polygon-thick-border-grey.5e12de19.svg";